import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import TabDrive from './TabDrive'
import TabPrototype from './TabPrototype'
import TabMedia from './TabMedia'

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div style={{width: '105%',  marginTop: '0.4rem', marginLeft: '-1.5rem' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', textAlign: 'center' }}>
      <Box sx={{ borderBottom: 1, 
        borderColor: 'divider', 
        width: '100%', // Or a specific width
        overflowX: 'auto', // Enable horizontal scrolling
        display: 'flex', // Arrange children horizontally
        flexDirection: 'row',
        flex: '0 0 auto', /* Essential: keeps items from shrinking */
        // gap: 1, // Add some spacing between items
        // p: 1, // Padding inside the box
        justifyContent:'center',
        alignItems:'center'}}>
        <Tabs value={value} onChange={handleChange}   sx={{".Mui-selected": {fontWeight: `bold`,},
  }} >
          <Tab label="V-Drive" {...a11yProps(0)} />
          <Tab label="Prototype" {...a11yProps(1)} />   
          <Tab label="Visual media" {...a11yProps(2)} />              
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <TabDrive />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <TabPrototype />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <TabMedia />
      </CustomTabPanel>          
    </Box>
  );
}